module.exports = __webpack_public_path__ + "static/media/Heroku_Badge.7dd506e7.png";